import { createClient } from '@supabase/supabase-js';
import type { Database } from '@jeraisonne/db';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!url || !anonKey) {
  throw new Error('VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY sont requis.');
}

export const supabaseUrl = url;

// Même config que apps/app/src/lib/supabase.ts (flowType: 'pkce') — même si
// cette app n'utilise pas signInWithOAuth, on garde le même client de base
// pour rester cohérent avec le reste du projet. La session établie ici via
// `setSession` (handoff) est isolée par ORIGINE (tutor.jeraisonne.fr) — le
// navigateur scope localStorage nativement, pas besoin de clé custom.
export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    flowType: 'pkce',
  },
});
